export const getCollectionLabel = (colName) => {
  const labels = {
    students: "학생",
    teachers: "교사",
    schedules: "일정",
    finances: "재정",
    visitLogs: "방문기록",
    meetingMinutes: "회의록",
  };
  return labels[colName] || colName;
};

export const formatNameSummary = (names = [], maxVisible = 3) => {
  if (!Array.isArray(names) || names.length === 0) return "";
  if (names.length > maxVisible) {
    return `${names.slice(0, maxVisible).join(", ")} 외 ${names.length - maxVisible}명`;
  }
  return names.join(", ");
};
